import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsTab } from "@/components/admin/AnalyticsTab";

export const Route = createFileRoute("/admin/analytics")({
  head: () => ({ meta: [{ title: "Analytics · Admin · INFLOW Marketing" }, { name: "description", content: "Funnel performance across visitors, CTA clicks, and completions." }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Analytics</h1>
        <p className="text-sm text-muted-foreground mt-1">Funnel performance across visitors, CTA clicks, and completions.</p>
      </div>
      <AnalyticsTab />
    </div>
  ),
});
